// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportHistoryStore.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Izenda Report History Store
 */
!(function() {
  var m = require('mobx');
  var fetcher = require('fetchers/Izenda.ReportsDataFetcher');
  var ReportHistoryModel = require('./models/Izenda.ReportHistory');
  var { remove } = require('lodash/fp');

  function ReportHistoryStore() {
    this.model = new ReportHistoryModel();
    this.reportId = null;
  }

  /**
   * Read initial data
   */
  ReportHistoryStore.prototype.init = function(reportId) {
    this.reportId = reportId;

    return this.loadReportHistory();
  };

  /**
   * Load report history
   */
  ReportHistoryStore.prototype.loadReportHistory = function() {
    var model = this.model;
    model.pageInfo.buildPagingRequest();

    return fetcher.loadReportHistory(null, model.pageInfo, this.reportId).then(model.readHistory.bind(model));
  };

  /**
   * Go to page
   * @param {type} pageIndex
   * @returns {type}
   */
  ReportHistoryStore.prototype.goToPage = function(pageIndex) {
    var pageInfo = this.model.pageInfo;

    pageInfo.setPageIndex(pageIndex);

    return this.loadReportHistory();
  };

  /**
   * Search Report History
   * @param {type} searchProperty
   * @param {type} searchText
   * @returns {type}
   */
  ReportHistoryStore.prototype.search = function(searchProperty, searchText) {
    this.model.pageInfo.setSearchValues(searchProperty, searchText);

    return this.goToPage(1);
  };

  /**
   * Change sort orders
   * @param {type} columnKey
   * @param {type} sortDir
   */
  ReportHistoryStore.prototype.onSortChange = function(columnKey, sortDir) {
    this.model.pageInfo.setColSortDirs(columnKey, sortDir);

    return this.loadReportHistory();
  };

  /**
   * Change page size
   * @param {type} pageSize
   * @returns {type}
   */
  ReportHistoryStore.prototype.onPageSizeChange = function(pageSize) {
    this.model.pageInfo.setPageSize(pageSize);

    return this.goToPage(1);
  };

  /**
   * On change Seach properties
   * @param {type} searchProperty
   * @param {type} searchText
   * @returns {type}
   */
  ReportHistoryStore.prototype.onSearchPropertiesChange = function(searchProperty, searchText) {
    this.model.pageInfo.setSearchValues(searchProperty, searchText);
  };

  /**
   * Delete Report
   * @param {String} reportId
   * @param {String} version
   * @returns {Promise}
   */
  ReportHistoryStore.prototype.deleteReportHistory = m.action(function(reportId, version) {
    return fetcher
      .deleteReportHistory(reportId, version)
      .then(
        function(result) {
          var histories = this.model.histories;
          this.model.histories = remove(function(item) {
            return item.version === version;
          }, histories);
          return result;
        }.bind(this)
      )
      .then(this.loadReportHistory.bind(this));
  });

  module.exports = ReportHistoryStore;
})();



// WEBPACK FOOTER //
// ./ui/logic/Izenda.ReportHistoryStore.js